export const galleryData = [
  {
    key: "people",
    path:"/img/gallery/p1.jpg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p2.jpg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p3.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p4.jpeg",
    name:""
  },
  {
    key: "people",
    path:"/img/gallery/p5.jpg",
    name:""
  },
  {
    key: "people",
    path:"/img/gallery/p6.jpg",
    name:""
  },
  {
    key: "others",
    path:"/img/gallery/p7.jpg",
    name:""
  },
  {
    key: "people",
    path:"/img/gallery/p8.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p9.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p10.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p11.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p12.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p13.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p14.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p15.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p16.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p17.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p18.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p19.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p20.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p21.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p22.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p23.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p24.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p25.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p30.jpg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p28.jpg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/p29.jpg",
    name:""
  },

  {
    key: "others",
    path:"/img/gallery/p26.jpeg",
    name:""
  },
  {
    key: "people",
    path:"/img/gallery/p27.jpeg",
    name:""
  },
    //************** Landscape images ******************************
  {
    key: "others",
    path:"/img/gallery/l1.jpeg",
    name:""
  },
  {
    key: "people",
    path:"/img/gallery/l2.jpeg",
    name:""
  },
  {
    key: "people",
    path:"/img/gallery/l3.jpg",
    name:""
  },
  {
    key: "others",
    path:"/img/gallery/l4.jpeg",
    name:""
  },
  {
    key: "others",
    path:"/img/gallery/l5.jpeg",
    name:""
  },
  {
    key: "products",
    path:"/img/gallery/l6.jpeg",
    name:""
  },
  {
    key: "others",
    path:"/img/gallery/l7.jpg",
    name:""
  },
  {
    key: "people",
    path:"/img/gallery/l8.webp",
    name:""
  },
    {
        key: "people",
        path:"/img/gallery/l16.jpeg",
        name:""
    },
    {
        key: "people",
        path:"/img/gallery/l17.jpeg",
        name:""
    },
  {
    key: "people",
    path:"/img/gallery/l9.jpeg",
    name:""
  },
  {
    key: "people",
    path:"/img/gallery/l10.jpg",
    name:""
  },
  {
    key: "others",
    path:"/img/gallery/l11.jpeg",
    name:""
  },
  {
    key: "others",
    path:"/img/gallery/l12.jpeg",
    name:""
  },
  {
    key: "people",
    path:"/img/gallery/l13.jpeg",
    name:""
  },
  {
    key: "people",
    path:"/img/gallery/l14.jpeg",
    name:""
  },
  {
    key: "others",
    path:"/img/gallery/l15.jpeg",
    name:""
  },
]